import { UNIT_TYPES } from '@/utils/constants'

export const DATAZAP_STAMPS = {
  SALE: 'DATAZAP_APPROVED_SALE',
  RENTAL: 'DATAZAP_APPROVED_RENTAL',
}

export const DEVELOPMENT = 'DEVELOPMENT'
export const SALE = 'SALE'
export const RENTAL = 'RENTAL'
export const USED = 'USED'

export const BUSINESS_TYPES_MASP_COMPONENT = [
  {
    value: SALE,
    label: 'Comprar',
    class: 'js-sale',
  },
  {
    value: RENTAL,
    label: 'Alugar',
    class: 'js-rental',
  },
]

// TODO: check if is used
export const DEFAULT_FILTERS_VALUES = {
  bathrooms: 0,
  bedrooms: 0,
  displayAddressType: undefined,
  parkingSpaces: 0,
  priceMax: '',
  priceMin: '',
  usableAreasMax: undefined,
  usableAreasMin: undefined,
  externalId: undefined,
  amenities: undefined,
  stamps: undefined,
  unitTypes: UNIT_TYPES.UNIT_TYPE_DEFAULT,
  categoryPage: 'RESULT',
  parentId: 'null',
  addresses: [],
  hasVideosOrVirtualTour: false,
  hasVirtualTour: false,
  warranties: '',
  mapSearch: false,
  constructionStatus: undefined,
}

